import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const Experience = () => {
  const handleDownload = () => {
    // Provide the path to your CV file here
    const link = document.createElement("a");
    link.href = "../assets/resumeVikram.pdf";
    link.download = "vikramResume.pdf";
    link.click();
  };

  return (
    <section id="experience" className="pt-32 pb-16">
      {/* HEADING */}
      <motion.div
        className="md:w-1/3 text-center md:text-left"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <p className="text-4xl mb-5">
          <span className="font-playfair text-4xl text-red">My</span>{" "}
          <span className="font-acorn text-4xl text-red">Experience</span>
        </p>
        <LineGradient width="mx-auto w-4/5" />
        <div className="text-left mt-5">
        <p className="mt-10">
            I have experience in software development, teaching, and research. Download my CV to learn more.
        </p>
  <button
    onClick={handleDownload}
    className="bg-red text-white font-semibold py-3 px-8 rounded-md transition duration-300 transform hover:scale-105 hover:bg-dark-red hover:text-white mt-6"
    style={{ boxShadow: "0px 4px 15px rgba(255, 0, 0, 0.4)" }}
  >
    Download CV
  </button>
</div>
      </motion.div>

      {/* DOWNLOAD CV BUTTON */}
      


      {/* EXPERIENCE CARDS */}
      <div className="md:flex md:justify-between gap-8">
        <motion.div
          className="mx-auto relative bg-blue max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-48
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 before:content-person1"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <p className="font-playfair text-3xl font-semibold text-center mt-4">Graduate Student Instructor</p>
          <p className="text-center text-xl">
          Teaching technologies and guiding projects while conducting independent research.
                    </p>
        </motion.div>

        <motion.div
          className="mx-auto relative bg-red max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-48
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 before:content-person1"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <p className="font-playfair text-3xl font-semibold text-center mt-4">ESIEA Lab Instructor</p>
          <p className="text-center text-xl">
          Taught web development to students from École supérieure d'informatique, électronique, automatique.
                    </p>
        </motion.div>

        <motion.div
            className="mx-auto relative bg-yellow max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-48
                before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 before:content-person1"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            variants={{
                hidden: { opacity: 0, scale: 0.8 },
                visible: { opacity: 1, scale: 1 },
            }}
            >
            <p className="font-playfair text-3xl font-semibold text-center mt-4">Grader for CIS-435</p>
            <p className="text-center text-xl">
            Assessed assignments and provided constructive feedback to support student growth and understanding in web technologies.
            </p>
    </motion.div>

      </div>
    </section>
  );
};

export default Experience;
